import { render, staticRenderFns } from "./MachineLearning.vue?vue&type=template&id=5876b2eb"
import script from "./MachineLearning.vue?vue&type=script&lang=js"
export * from "./MachineLearning.vue?vue&type=script&lang=js"
import style0 from "./MachineLearning.vue?vue&type=style&index=0&id=5876b2eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports